import Records from "./data.json";
import {useState} from "react";

function Comp(){
    const [state, setState] = useState();
    const test=(e)=>{
        setState(e.target.value);
    }
    return(
        <>
            <div className="container bg-info">
                <div className="row">
                    <div className="mb-3">
                        <label className="form-label">City Name</label>
                        <input type="text" className="form-control" onChange={test} value={state}/>
                    </div>
                </div>
                <div className="row">
                    {Records.filter(x=>x.name.includes(state)).map((record)=>{
                        return(
                            <div className="col-md-3">
                                <div className="card mt-2">
                                    <img src={record.pic} className="card-img-top" alt=""/>
                                    <div className="card-body">
                                        <h5 className="card-title text-center">{record.id}.{record.name}</h5>
                                        <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                    </div>
                                </div> 
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}
export default Comp